import { CommonModule } from '@angular/common';
import {
    Component,
    OnInit
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';

import { AppMenuitem } from './app.menuitem';

import { AuthService } from '@/auth/services';

@Component({
    selector: 'app-menu',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule],
    template: `
        <ul class="layout-menu">
            @for (item of model; track $index) {
                @if (item.separator) {
                    <li class="menu-separator"></li>
                } @else {
                    <li app-menuitem [item]="item" [index]="$index" [root]="true"></li>
                }
            }
        </ul>
    `
})
export class AppMenu implements OnInit {
    model: MenuItem[] = [];

    constructor(private authService: AuthService) {
    }

    ngOnInit() {
        const homeItems: MenuItem[] = [
            { label: 'Users', icon: 'pi pi-fw pi-users', routerLink: ['/'] },
            { label: 'Rates', icon: 'pi pi-fw pi-dollar', routerLink: ['/rates'] },
            { label: 'Services', icon: 'pi pi-fw pi-briefcase', routerLink: ['/service-mappings'] },
            { label: 'Rate units', icon: 'pi pi-fw pi-clock', routerLink: ['/rate-unit-mappings'] },
            { label: 'Districts', icon: 'pi pi-fw pi-building', routerLink: ['/districts'] },
            { label: 'Competitors', icon: 'pi pi-fw pi-users', routerLink: ['/competitor-mappings'] },
            { label: 'Documents', icon: 'pi pi-fw pi-file', routerLink: ['/documents'] },
            { label: 'Action Logs', icon: 'pi pi-fw pi-list', routerLink: ['/action-logs'] },
        ];

        if (this.authService.hasPermission('districts.district_processing_statistics.read')) {
            homeItems.push({
                label: 'Pipeline statistics',
                icon: 'pi pi-fw pi-chart-bar',
                routerLink: ['/statistics']
            });
        }

        if (this.authService.hasPermission('settings.web_visibility_rules.read')) {
            homeItems.push({ label: 'App Settings', icon: 'pi pi-fw pi-cog', routerLink: ['/app-settings'] });
        }

        this.model = [
            {
                label: 'Home',
                items: homeItems,
            },
        ];
    }
}
